export const ProductTabType = Object.freeze({
  DOWNLOAD: "DOWNLOAD",
  TECHNICAL: "TECHNICAL",
  SOFTWARE: "SOFTWARE",
  TRAINING: "TRAINING",
  SQUARE: "SQUARE",
  SAMPLE_STORE: "SAMPLE_STORE",
  SW_SERVICE: "SW_SERVICE",

  WIRING: "WIRING",
  PARAMETER: "PARAMETER",
  // KEYPAD_COMPOSITION: "KEYPAD_COMPOSITION",
  // PARAMETER_GROUP_COMPOSITION: "PARAMETER_GROUP_COMPOSITION",
  // PARAMETER_SETTING: "PARAMETER_SETTING",
  // KEYPAD_SIMULATION: "KEYPAD_SIMULATION",


  SPECIFICATIONS: "SPECIFICATIONS",
  OPTION_LIST: "OPTION_LIST",
  OPERATION_MANUAL: "OPERATION_MANUAL",
  MANUAL_DOWNLOAD: "MANUAL_DOWNLOAD",
  QUICK_GUIDE: "QUICK_GUIDE",

  TROUBLESHOOTING: "TROUBLESHOOTING",
  // FAULT_TRIPS_OCCURS: "FAULT_TRIPS_OCCURS",
  // AFTER_A_TEST_RUN: "AFTER_A_TEST_RUN",
  // MAINTENANCE: "MAINTENANCE",
  // FAULT_TRIPS: "FAULT_TRIPS",
  // OTHER_FAULTS: "OTHER_FAULTS",
  // TRIP: "TRIP",
  // TRIPS_AND_WARNING: "TRIPS_AND_WARNING",
});

export const getDocTypeLangKey = (value: string) => {
  switch (value) {
    case ProductTabType.DOWNLOAD:
      return 'I18N_TAB_DOWNLOAD';
    case ProductTabType.TECHNICAL:
      return 'I18N_TAB_TECHNICAL';
    case ProductTabType.SOFTWARE:
      return 'I18N_TAB_SOFTWARE';
    case ProductTabType.TRAINING:
      return 'I18N_TAB_TRAINING';
    case ProductTabType.SQUARE:
      return 'I18N_TAB_SQUARE';
    case ProductTabType.SAMPLE_STORE:
      return 'I18N_TAB_SAMPLE';
    case ProductTabType.SW_SERVICE:
      return 'I18N_TAB_SW_SERVICE';
    case ProductTabType.WIRING:
      return 'I18N_QR_MANUAL_WIRING';
    case ProductTabType.PARAMETER:
      return 'I18N_QR_MANUAL_PARAMETER';
    case ProductTabType.SPECIFICATIONS:
      return 'I18N_QR_MANUAL_SPECIFICATIONS';
    case ProductTabType.OPTION_LIST:
      return 'I18N_QR_MANUAL_OPTION_LIST';
    case ProductTabType.OPERATION_MANUAL:
      return 'I18N_QR_MANUAL_OPERATION_MANUAL';
    case ProductTabType.TROUBLESHOOTING:
      return 'I18N_QR_MANUAL_TROUBLESHOOTING';
    case ProductTabType.MANUAL_DOWNLOAD:
      return 'I18N_QR_MANUAL_MANUAL_DOWNLOAD';
    case ProductTabType.QUICK_GUIDE:
      return 'I18N_QR_MANUAL_QUICK_GUIDE';
    default:
      return '';
  }
};
